import React, { forwardRef } from 'react';

const RecipeTypeDefaultsIcon = forwardRef((props, ref) => {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z"
        fill="#E3E9FF"
      />
      <path
        d="M19.7199 10.348L14.8449 9.319L12.3599 5V16.967L16.9089 19L16.3809 14.045L19.7199 10.348Z"
        fill="#FFCD00"
      />
      <path
        d="M9.875 9.319L5 10.348L8.34 14.048L7.812 19L12.36 16.967V5L9.875 9.319Z"
        fill="#FFDA44"
      />
    </svg>
  );
});

export default RecipeTypeDefaultsIcon;
